import { client } from './client'
import type { Connector, ConnectorType, ProviderRepositoryInfo, ProviderBranchInfo, ProviderFileInfo, SaveTokenRequest, SaveTokenResponse, TitanEndpointStatus, DeviceFlowInitiation, DeviceFlowPollResult, SaveDatabaseConnectorRequest, SaveDatabaseConnectorResponse, AzureDevOpsProjectInfo, WikiInfo, WikiListItem, WikiPageNode, CreateSonarQubeConnectionResponse, SaveSonarQubeConnectionRequest, SonarQubeConnection, TestSonarQubeConnectionRequest } from '@/types'

export const connectorsApi = {
  getAll: (projectId: string) =>
    client.get<Connector[]>(`/projects/${projectId}/connectors`).then(r => r.data),

  saveToken: (projectId: string, connectorType: ConnectorType, data: SaveTokenRequest) =>
    client.post<SaveTokenResponse>(`/projects/${projectId}/connectors/${connectorType}/token`, data).then(r => r.data),

  getTitanEndpointStatus: (projectId: string) =>
    client.get<TitanEndpointStatus>(`/projects/${projectId}/connectors/qubiz-titan/endpoint-status`).then(r => r.data),

  initiateCopilotDeviceFlow: (projectId: string) =>
    client.post<DeviceFlowInitiation>(`/projects/${projectId}/connectors/github-copilot/device-flow/initiate`).then(r => r.data),

  pollCopilotDeviceFlow: (projectId: string, flowId: string) =>
    client.post<DeviceFlowPollResult>(`/projects/${projectId}/connectors/github-copilot/device-flow/poll`, { flowId }).then(r => r.data),

  saveDatabaseConnector: (projectId: string, data: SaveDatabaseConnectorRequest) =>
    client.post<SaveDatabaseConnectorResponse>(`/projects/${projectId}/connectors/database`, data).then(r => r.data),

  deleteDatabaseConnector: (projectId: string, connectorId: string) =>
    client.delete(`/projects/${projectId}/connectors/database/${connectorId}`).then(r => r.data),

  getSonarQubeConnection: (projectId: string) =>
    client.get<SonarQubeConnection | null>(`/projects/${projectId}/connectors/sonarqube-connection`).then(r => r.data),

  createSonarQubeConnection: (projectId: string, data: SaveSonarQubeConnectionRequest) =>
    client.post<CreateSonarQubeConnectionResponse>(`/projects/${projectId}/connectors/sonarqube-connection`, data).then(r => r.data),

  updateSonarQubeConnection: (projectId: string, data: SaveSonarQubeConnectionRequest) =>
    client.put(`/projects/${projectId}/connectors/sonarqube-connection`, data),

  disableSonarQubeConnection: (projectId: string) =>
    client.delete(`/projects/${projectId}/connectors/sonarqube-connection`),

  testSonarQubeConnection: (projectId: string, data: TestSonarQubeConnectionRequest) =>
    client.post(`/projects/${projectId}/connectors/sonarqube-connection/test`, data),

  disconnect: (projectId: string, connectorType: ConnectorType) =>
    client.delete(`/projects/${projectId}/connectors/${connectorType}`).then(r => r.data),

  listRepositories: (projectId: string, connectorType: ConnectorType, search?: string) =>
    client.get<ProviderRepositoryInfo[]>(`/projects/${projectId}/connectors/${connectorType}/repositories`, { params: { search } }).then(r => r.data),

  listBranches: (projectId: string, connectorType: ConnectorType, repository: string, search?: string) =>
    client.get<ProviderBranchInfo[]>(`/projects/${projectId}/connectors/${connectorType}/branches`, { params: { repository, search } }).then(r => r.data),

  listFiles: (projectId: string, connectorType: ConnectorType, repository: string, branch?: string, search?: string) =>
    client.get<ProviderFileInfo[]>(`/projects/${projectId}/connectors/${connectorType}/files`, { params: { repository, branch, search } }).then(r => r.data),

  listWikiProjects: (projectId: string) =>
    client.get<AzureDevOpsProjectInfo[]>(`/projects/${projectId}/connectors/azure-devops/wiki-projects`).then(r => r.data),

  listWikis: (projectId: string, project: string) =>
    client.get<WikiInfo[]>(`/projects/${projectId}/connectors/azure-devops/wikis`, { params: { project } }).then(r => r.data),

  listWikiPages: (projectId: string, project: string, wikiId: string) =>
    client.get<WikiPageNode>(`/projects/${projectId}/connectors/azure-devops/wiki-pages`, { params: { project, wikiId } }).then(r => r.data),

  listAllWikis: (projectId: string) =>
    client.get<WikiListItem[]>(`/projects/${projectId}/connectors/azure-devops/all-wikis`).then(r => r.data),
}
